(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hf-custom-quote"] && !Shopify.designMode) return;
  try {
    
  function initializeQuoteProcess(container = document) {
    const processes = new Map([
      ['3d-printing', '3D Printing'],
      ['cnc-routing', 'CNC Routing'],
      ['laser', 'Laser Cutting or Engraving'],
      ['cnc-machining', 'Machining - future availability'],
    ]);
    const storageKey = 'hf-quote-project-type-v1';

    container.querySelectorAll('[data-hf-quote-form]').forEach((form) => {
      const select = form.querySelector('#HFProjectType');
      if (!select || select.dataset.processInitialized) return;
      select.dataset.processInitialized = 'true';
      const allowedValues = new Set(Array.from(select.options, (option) => option.value));
      let savedValue = '';

      // Store only this non-sensitive category, never the customer's form details.
      try {
        if (form.dataset.postedSuccessfully === 'true') {
          sessionStorage.removeItem(storageKey);
        } else {
          savedValue = sessionStorage.getItem(storageKey) || '';
        }
      } catch {
        // Native selection and query preselection also work with storage disabled.
      }

      if (!select.value) {
        if (form.dataset.hasErrors === 'true' && allowedValues.has(savedValue)) {
          select.value = savedValue;
        } else if (form.dataset.postedSuccessfully !== 'true') {
          const requestedProcess = new URLSearchParams(window.location.search).get('process');
          const requestedValue = processes.get(requestedProcess);
          if (requestedValue && allowedValues.has(requestedValue)) select.value = requestedValue;
        }
      }

      const rememberSelection = () => {
        if (!allowedValues.has(select.value)) return;
        try {
          sessionStorage.setItem(storageKey, select.value);
        } catch {
          // Keep the browser's current native selection if storage is unavailable.
        }
      };
      select.addEventListener('change', rememberSelection);
      rememberSelection();
    });
  }

  initializeQuoteProcess();
  document.addEventListener('shopify:section:load', (event) => initializeQuoteProcess(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-home"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-hf-quote-anchor]');
    if (!link) return;
    const target = document.getElementById('instant-quote');
    if (!target) return;
    event.preventDefault();
    target.focus({ preventScroll: true });
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
    history.replaceState(null, '', '#instant-quote');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-manufacturing-fulfillment"]) return;
  try {
    
  const form = document.getElementById('FabCoSellerInquiry');
  if (form) {
    const draftKey = 'fabco-seller-inquiry-validation';
    const fields = Array.from(form.querySelectorAll('input:not([type="hidden"]), textarea'));
    try {
      const saved = JSON.parse(sessionStorage.getItem(draftKey) || 'null');
      sessionStorage.removeItem(draftKey);
      if (form.querySelector('#seller-errors') && saved && Date.now() - saved.time < 600000) {
        for (const field of fields) {
          if (!Object.hasOwn(saved.values, field.name)) continue;
          const value = saved.values[field.name];
          if (field.type === 'checkbox') field.checked = value === true;
          else if (!field.value && typeof value === 'string') field.value = value;
        }
      }
    } catch {
      // Shopify still displays its native values and errors if storage is unavailable.
    }

    form.addEventListener('submit', (event) => {
      if (event.defaultPrevented || !form.checkValidity()) return;
      try {
        const values = Object.fromEntries(
          fields.map((field) => [field.name, field.type === 'checkbox' ? field.checked : field.value]),
        );
        sessionStorage.setItem(draftKey, JSON.stringify({ time: Date.now(), values }));
      } catch {
        // Allow the native contact submission when storage is unavailable.
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
